import React from 'react';
import { Wrapper, Title, Image, Text } from './styled';
import UnderConstruction from 'assets/coming-soon.svg';
import Fade from 'react-reveal/Fade';

const ComingSoon = () => {
	return (
		<Fade>
			<Wrapper>
				<Image src={UnderConstruction} alt='Coming Soon' />
				<Title>Coming Soon</Title>
				<Text>
					This page is currently being built and will be available
					very soon
				</Text>
			</Wrapper>
		</Fade>
	);
};

export default ComingSoon;
